
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/static-site-router",
      function () {
        return require("private-next-pages/static-site-router.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/static-site-router"])
      });
    }
  